import * as Sentry from "@sentry/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === "true",
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "light",
      autoInject: false,
      enableScreenshot: true,
      useSentryUser: { name: "username", email: "email" },
      themeLight: {
        accentBackground: "#00286f",
        accentForeground: "#ffffff",
        background: "#ffffff",
        foreground: "#1e293b",
        successColor: "#0f8a5f",
        errorColor: "#c62828",
      },
    }),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
